/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import Progress from "../Progress/Progress";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import "./ProductInformation.scss";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../context/GlobalContext";
import { useContext } from "react";
import HelpSection from "../../Common/HelpSection/HelpSection";
import CardButtonLeftArrow from "../../../assets/CardButtonLeftArrow.svg";
import Mobile from "./Mobile/Mobile";
import SIP from "./SIP/SIP";
import Fiber from "./Fiber/Fiber";
interface Props {
  rtl?: boolean;
  dir?: string;
}

function ProductInformation({ rtl, }: Props) {
  const [state, dispatch]: any = useContext(GlobalContext);
  const { t } = useTranslation();
  const dir = rtl ? "right" : "left";
  
  const handleBack = () => {
    dispatch({ type: 'SET_BACK_BUTTON', payload: { page: t("Account_Information") } })
  }
  let productForm = <Mobile/>
  let productDescription = t("Mobily_Business_Voice_postpaid_category");
  if (state.productType === 'Voice') {
    productForm = <Mobile/>
  } else if (state.productType === 'SIP') {
    productForm = <SIP />
    productDescription = t("Mobile_Product_Description");
  } else if (state.productType === 'Fiber') {
    productForm = <Fiber />
    productDescription = t("Mobile_Product_Description");
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 d-flex">
          <div className={`back-icon-container ${dir}`} onClick={handleBack}>
            <img className={`back-icon`} src={CardButtonLeftArrow} alt="arrow" />
          </div>
          <Progress rtl={rtl} title={t('Product_Information')} />
        </div>
        <div className={`col-sm-12 container-ar-${dir} order-detail-popup`}>
          <div className='ProductInformation__headerSection flex-column-reverse-mobile'>
            <div className={`product-information-text-container text-container-${dir} col-sm-8`}>
              <Typography rtl={rtl} className="form-title">{t("Product_Information")}</Typography>
              <Typography rtl={rtl} className="product-information-text">{productDescription}</Typography>
            </div>
            <HelpSection rtl={rtl} />
          </div>
          {productForm}
        </div>
      </div>
    </div>
  );
}

export default ProductInformation;
